import { Badge, Button, Card, CardBody, FormControl, FormHelperText, FormLabel, HStack, IconButton, Input, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Select, Stack, Text, Textarea, useDisclosure } from '@chakra-ui/react';
import { FiEdit2, FiMoreVertical } from 'react-icons/fi';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks';

import { DeleteServiceButton } from './DeleteService';
import { ToastContainer } from 'react-toastify';
import { editService } from '../../../store/actions';
import { editServiceFormValidation } from '../../../utils';
import { serviceType } from '../../../types';
import { useFormik } from 'formik';

export const ServiceCard = ({ service }: { service: serviceType }) => {

    const { isOpen, onOpen, onClose } = useDisclosure();

    const { is_editing_service } = useAppSelector(state => state.servicesReducer);

    const dispatch = useAppDispatch();

    const editServiceForm = useFormik({
        initialValues: {
            company_id: '',
            service_id: '',
            name: '',
            description: '',
            is_active: true,
        },
        validationSchema: editServiceFormValidation,
        validateOnBlur: true,
        onSubmit: (values: serviceType) => {
            dispatch(editService(values)).then(() => onClose());
            // alert(JSON.stringify(values));
        },
    });

    const setFormValues = () => {
        editServiceForm.setFieldValue('company_id', service?.company_id);
        editServiceForm.setFieldValue('service_id', service?.service_id);
        editServiceForm.setFieldValue('name', service?.name);
        editServiceForm.setFieldValue('description', service?.description);
        editServiceForm.setFieldValue('is_active', service?.is_active);
    };

    useEffect(() => {
        setFormValues();
    }, []);

    return (
        <>
            <Card boxShadow={'md'}>
                <CardBody>
                    <HStack justifyContent={'space-between'}>
                        <Text fontSize={'lg'} fontWeight={'medium'} textTransform={'capitalize'}>{service?.name}</Text>
                        <Menu>
                            <MenuButton
                                as={IconButton}
                                aria-label='Options'
                                icon={<FiMoreVertical />}
                                variant='ghost'
                                size={'sm'}
                            />
                            <MenuList>
                                <MenuItem icon={<FiEdit2 size={16} />} onClick={onOpen}>
                                    Edit
                                </MenuItem>
                                <DeleteServiceButton id={`${service?.service_id}`} />
                            </MenuList>
                        </Menu>
                    </HStack>
                    <Badge colorScheme={service?.is_active ? 'green' : 'red'}>{service?.is_active ? 'active' : 'deactived'}</Badge>
                    <Text color={'gray.500'} mt={2}>{service?.description}</Text>
                </CardBody>
                <ToastContainer />
            </Card>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader textTransform={'capitalize'}>Edit <strong>{service?.name}</strong> service</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <form onSubmit={editServiceForm.handleSubmit}>
                            <Stack mb={3}>
                                <FormControl isRequired>
                                    <FormLabel>Name</FormLabel>
                                    <Input name='name' value={editServiceForm.values.name} onChange={editServiceForm.handleChange} onBlur={editServiceForm.handleBlur} />
                                    {editServiceForm.errors.name && <Text color={'red.500'} fontSize={'sm'}>{editServiceForm.errors.name}</Text>}
                                </FormControl>
                                <FormControl isRequired>
                                    <FormLabel>Active</FormLabel>
                                    <Select name='is_active' value={`${editServiceForm.values.is_active}`} onChange={editServiceForm.handleChange} onBlur={editServiceForm.handleBlur}>
                                        <option value={'true'}>True</option>
                                        <option value={'false'}>False</option>
                                    </Select>
                                    {editServiceForm.errors.is_active && <Text color={'red.500'} fontSize={'sm'}>{editServiceForm.errors.is_active}</Text>}
                                </FormControl>
                                <FormControl pb={3} isRequired>
                                    <FormLabel>Description</FormLabel>
                                    <Textarea name='description' value={editServiceForm.values.description} onChange={editServiceForm.handleChange} onBlur={editServiceForm.handleBlur} />
                                    <FormHelperText textAlign={'right'}>{editServiceForm.values.description.length}/80</FormHelperText>
                                    {editServiceForm.errors.description && <Text color={'red.500'} fontSize={'sm'}>{editServiceForm.errors.description}</Text>}
                                </FormControl>
                                <Button
                                    mt={4}
                                    type='submit'
                                    colorScheme={'yellow'}
                                    isDisabled={!editServiceForm.isValid || is_editing_service}
                                    loadingText={'Submitting...'}
                                    isLoading={is_editing_service}
                                >
                                    Submit
                                </Button>
                            </Stack>
                        </form>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};